import { useState } from 'react';

export interface FormulaDisclosureProps {
  lines: string[];
  fetchedAt: string;
  apiSource?: string;
}

function formatDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return iso;
  }
}

/**
 * Collapsed by default "Why this number?" disclosure.
 * Shows formula lines in monospace, source attribution, and fetch date.
 */
export function FormulaDisclosure({
  lines,
  fetchedAt,
  apiSource = 'Azure Retail Prices API',
}: FormulaDisclosureProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-2 text-[11px]">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1 transition-colors font-mono"
        style={{ color: 'var(--text-tertiary)' }}
      >
        <span className="text-[10px]">{open ? '▼' : '▶'}</span>
        <span>Why this number?</span>
      </button>

      {open && (
        <div className="mt-2 pl-3 flex flex-col gap-0.5" style={{ borderLeft: '1px solid var(--outline-variant)' }}>
          {lines.map((line, idx) => (
            <p
              key={idx}
              className="font-mono text-[11px] whitespace-pre-wrap leading-relaxed"
              style={{ color: 'var(--text-tertiary)' }}
            >
              {line}
            </p>
          ))}
          <p className="font-mono text-[10px] mt-1" style={{ color: 'var(--text-tertiary)' }}>
            Price fetched: {formatDate(fetchedAt)} from {apiSource}
          </p>
        </div>
      )}
    </div>
  );
}
